module.exports = __webpack_public_path__ + "media/images/flags/32/North-Korea-44ff4006f0d08ca576f4c44bc341aa44.png";